/* fc-moments-home.js (2026-10-12 speed pass): the moments tabs, autoplay and the liquid-glass sliding lens.
   Moved out of sections/fc-moments-home.liquid so browsers cache it across pages; the
   root is #fc-fmh and per-instance values travel as data attributes. The
   body is the former inline script, unchanged apart from those lookups.
   Re-initialises on shopify:section:load for the theme editor. */
(function () {
  'use strict';
  function initSection(root) {

    var tabs = root.querySelectorAll('[data-fmh-tab]');
    var panels = root.querySelectorAll('[data-fmh-panel]');
    var total = tabs.length;
    if (!total) return;

    var autoplay = root.getAttribute('data-fc-autoplay') === 'true';
    var interval = parseInt(root.getAttribute('data-fc-interval'), 10) || 3000;
    var current = 1;
    var timer = null;

    var tabsEl = root.querySelector('.fm-tabs');

    /* Liquid-glass sliding lens (2026-08-21): one glass capsule travels to
       the active tab. Motion per Apple's Liquid Glass tab bar: the capsule
       stretches toward the target (leading edge first, like a droplet
       being pulled), briefly squashes while moving, overshoots the target
       a few px and springs back. Honors prefers-reduced-motion. */
    var glass = null;
    var glassAnim = null;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (tabsEl) {
      glass = document.createElement('span');
      glass.className = 'fm-tabs__glass';
      glass.setAttribute('aria-hidden', 'true');
      tabsEl.insertBefore(glass, tabsEl.firstChild);
      tabsEl.classList.add('has-glass');
    }
    /* True Apple-style edge refraction (2026-08-21): a displacement map
       sized to the capsule with a NEUTRAL BLURRED CENTER and edge-only
       X/Y ramps, applied via backdrop-filter: url(data-URI). Ported from
       the nikdelvin/liquid-glass pixel-perfect recreation. Chromium
       supports SVG url() in backdrop-filter; other engines keep the CSS
       ::after turbulence frost as fallback (has-lens class gates it). */
    var supportsUrlBackdrop = (function(){
      var el = document.createElement('div');
      el.style.cssText = 'backdrop-filter: url(#x)';
      return (el.style.backdropFilter || '').indexOf('url') === 0;
    })();
    function fcLensMap(w, h, r, depth){
      return 'data:image/svg+xml;utf8,' + encodeURIComponent(
        '<svg height="' + h + '" width="' + w + '" viewBox="0 0 ' + w + ' ' + h + '" xmlns="http://www.w3.org/2000/svg">' +
        '<defs>' +
        '<linearGradient id="Y" x1="0" x2="0" y1="' + Math.ceil((r / h) * 15) + '%" y2="' + Math.floor(100 - (r / h) * 15) + '%">' +
        '<stop offset="0%" stop-color="#0F0"/><stop offset="100%" stop-color="#000"/></linearGradient>' +
        '<linearGradient id="X" x1="' + Math.ceil((r / w) * 15) + '%" x2="' + Math.floor(100 - (r / w) * 15) + '%" y1="0" y2="0">' +
        '<stop offset="0%" stop-color="#F00"/><stop offset="100%" stop-color="#000"/></linearGradient>' +
        '</defs>' +
        '<rect x="0" y="0" height="' + h + '" width="' + w + '" fill="#808080"/>' +
        '<g filter="blur(2px)">' +
        '<rect x="0" y="0" height="' + h + '" width="' + w + '" fill="#000080"/>' +
        '<rect x="0" y="0" height="' + h + '" width="' + w + '" fill="url(#Y)" style="mix-blend-mode:screen"/>' +
        '<rect x="0" y="0" height="' + h + '" width="' + w + '" fill="url(#X)" style="mix-blend-mode:screen"/>' +
        '<rect x="' + depth + '" y="' + depth + '" height="' + (h - 2 * depth) + '" width="' + (w - 2 * depth) + '" fill="#808080" rx="' + r + '" ry="' + r + '" filter="blur(' + depth + 'px)"/>' +
        '</g></svg>');
    }
    function fcLensFilter(w, h, r, depth, strength){
      return 'data:image/svg+xml;utf8,' + encodeURIComponent(
        '<svg height="' + h + '" width="' + w + '" viewBox="0 0 ' + w + ' ' + h + '" xmlns="http://www.w3.org/2000/svg"><defs>' +
        '<filter id="d" color-interpolation-filters="sRGB">' +
        '<feImage x="0" y="0" height="' + h + '" width="' + w + '" href="' + fcLensMap(w, h, r, depth) + '" result="m"/>' +
        '<feDisplacementMap in="SourceGraphic" in2="m" scale="' + strength + '" xChannelSelector="R" yChannelSelector="G"/>' +
        '</filter></defs></svg>') + '#d';
    }
    function updateGlassLens(w, h){
      if (!glass || !supportsUrlBackdrop) return;
      h = h || glass.offsetHeight || 40;
      w = Math.round(w);
      var r = Math.round(h / 2);
      var depth = Math.max(6, Math.round(h * 0.18));
      var f = 'blur(1px) url(\'' + fcLensFilter(w, h, r, depth, 70) + '\') blur(2px) brightness(1.35) saturate(1.25)';
      glass.style.backdropFilter = f;
      glass.style.webkitBackdropFilter = f;
      glass.classList.add('has-lens');
    }
    function placeGlass(tab){
      if (!glass || !tab) return;
      /* Read every layout value before the first write (2026-10-13): the old order
         wrote left/width and then read offsetHeight, a forced reflow on every load. */
      var l = tab.offsetLeft, w = tab.offsetWidth, h = glass.offsetHeight || 40;
      glass.style.left = l + 'px';
      glass.style.width = w + 'px';
      updateGlassLens(w, h);
    }
    function travelGlass(fromTab, toTab){
      if (!glass || !toTab) return;
      if (!fromTab || fromTab === toTab || reduceMotion || typeof glass.animate !== 'function') {
        placeGlass(toTab);
        return;
      }
      var aL = fromTab.offsetLeft, aW = fromTab.offsetWidth;
      var bL = toTab.offsetLeft,  bW = toTab.offsetWidth;
      var gH = glass.offsetHeight || 40;
      var dist = bL - aL;
      /* Droplet stretch: elongate up to ~1.9x the larger pill, leading
         edge covering ~55% of the gap mid-flight. */
      var stretch = Math.min(Math.abs(dist) * 0.55 + Math.max(aW, bW), Math.max(aW, bW) * 1.9);
      var midL = dist >= 0 ? aL + dist * 0.25 : aL + dist * 0.75;
      var minL = Math.min(aL, bL), maxR = Math.max(aL + aW, bL + bW);
      if (midL < minL) midL = minL;
      if (midL + stretch > maxR) midL = maxR - stretch;
      var over = dist * 0.045; /* small overshoot, springs back */
      if (glassAnim) glassAnim.cancel();
      glass.style.left = bL + 'px';
      glass.style.width = bW + 'px';
      updateGlassLens(bW, gH);
      glassAnim = glass.animate([
        { left: aL + 'px',          width: aW + 'px',      transform: 'scaleY(1)',    offset: 0 },
        { left: midL + 'px',        width: stretch + 'px', transform: 'scaleY(0.93)', offset: 0.42 },
        { left: (bL + over) + 'px', width: bW + 'px',      transform: 'scaleY(1.02)', offset: 0.78 },
        { left: bL + 'px',          width: bW + 'px',      transform: 'scaleY(1)',    offset: 1 }
      ], { duration: 520, easing: 'cubic-bezier(0.3, 0.8, 0.3, 1)' });
    }

    function activate(idx){
      var s = String(idx);
      var activeTab = null;
      var prevTab = root.querySelector('.fm-tab.is-active');
      tabs.forEach(function(t){
        var active = t.getAttribute('data-fmh-tab') === s;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        if (active) activeTab = t;
      });
      travelGlass(prevTab, activeTab);
      panels.forEach(function(p){
        p.classList.toggle('is-active', p.getAttribute('data-fmh-panel') === s);
      });
      if (activeTab && tabsEl && tabsEl.scrollWidth > tabsEl.clientWidth) {
        var target = activeTab.offsetLeft - (tabsEl.clientWidth - activeTab.clientWidth) / 2;
        target = Math.max(0, Math.min(target, tabsEl.scrollWidth - tabsEl.clientWidth));
        if (typeof tabsEl.scrollTo === 'function') {
          tabsEl.scrollTo({ left: target, behavior: 'smooth' });
        } else {
          tabsEl.scrollLeft = target;
        }
      }
    }
    function tick(){
      current = current >= total ? 1 : current + 1;
      activate(current);
    }
    function startTimer(){
      if (!autoplay || total < 2 || timer) return;
      timer = setInterval(tick, interval);
    }
    function stopTimer(){
      if (timer) { clearInterval(timer); timer = null; }
    }
    function restartTimer(){
      stopTimer();
      startTimer();
    }

    tabs.forEach(function(tab){
      tab.addEventListener('click', function(){
        var idx = parseInt(tab.getAttribute('data-fmh-tab'), 10);
        current = idx;
        activate(idx);
        restartTimer();
      });
    });

    root.addEventListener('mouseenter', stopTimer);
    root.addEventListener('mouseleave', startTimer);
    document.addEventListener('visibilitychange', function(){
      if (document.hidden) stopTimer(); else startTimer();
    });

    /* Glass lens: initial seat + instant reseat when metrics change
       (viewport resize, webfont swap changing tab widths). */
    function reseatGlass(){ placeGlass(root.querySelector('.fm-tab.is-active')); }
    reseatGlass();
    var reseatRaf = null;
    window.addEventListener('resize', function(){
      if (reseatRaf) return;
      reseatRaf = requestAnimationFrame(function(){ reseatRaf = null; reseatGlass(); });
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(reseatGlass);
    window.addEventListener('load', reseatGlass);

    startTimer();
  
  }
  function init() {
    var root = document.getElementById('fc-fmh');
    if (!root || root.getAttribute('data-fc-init') === '1') return;
    root.setAttribute('data-fc-init', '1');
    initSection(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#fc-fmh')) init();
  });
})();
